import { Row as TableRowBase } from '@react-stately/table';
import { RowProps as TableRowBaseProps } from '@react-types/table';
import React from 'react';

export type TableRowProps = TableRowBaseProps<any>;

// Override TS for TableRow to support NextUI specific props.
const TableRow = TableRowBase as (props: TableRowProps) => React.JSX.Element;

export default TableRow;
